export default {
  views: {
    list: {
      header: {
        title: "Kljuke",
        search_placeholder: "Poišči kljuke po kodi ali proizvajalcu ...",
        add_button: "Dodaj kljuko",
        sync_button: "Posodobi zaloge",
        export_button: "Izvozi cenik"
      },
      table: {
        code: "Koda",
        vehicle: "Vozilo",
        supplier: "Proizvajalec",
        stock: "Zaloga"
      }
    },
    details: {
      header: {
        title: "Nova kljuka",
        back_button: "Seznam kljuk",
        save_button: "Shrani kljuko",
        delete_button: "Izbriši kljuko"
      },
      form: {
        headline: "Podatki",
        code: "Koda",
        supplier: "Proizvjalec",
        supplier_name: "Ime proizvjalca",
        price: "Cena",
        force: "D-vrednost",
        smpv: "SMPV",
        homologation: "Homologacija",
        type: "Tip",
        warehouse: "Skladišče",
        car: "Vozilo",
        limitations: "Omejitve",
        quantity: "Zaloga",
        install_cost: "Cena namestitve",
        install_duration: "Čas namestitve (min)",
        bumper_cutting: "Rezanje odbijača",
        bumper_cuttings: {
          nocut: "Brez reza",
          visible: "Vidno",
          invisible: "Nevidno"
        },
        vertical_load: "Vertikalna nosilnost",
        mass_vehicle: "Masa vozila",
        mass_coupling: "Masa spajanja",
        module: "Modul (da / ne)",
        hidden_plate: "Skrita tablica (da / ne)",
        bumper_removal: "Odstranjevanje odbijača",
        instructions: "Navodila",
        type_range: "Tip vlečnega droga",
        type_ranges: {
          cargo: "Tovorni",
          visible: "Vidno snemljivi",
          invisible: "Nevidno snemljivi"
        }
      }
    }
  },
  prompts: {
    delete: {
      title: "Izbriši kljuko",
      message: "Ste prepričani, da želite izbrisati kljuko {title}?",
      cancel: "Prekliči",
      confirm: "Izbriši"
    }
  },
  notify: {
    updated: "Kljuka {title} posodobljena",
    stored: "Kljuka dodana",
    deleted: "Kljuka {title} izbrisana",
    not_found: "Kljuke ni bilo mogoče najti"
  },
  actions: {
    open: "Odpri",
    edit: "Uredi",
    delete: "Izbriši"
  }
}
